import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

// import envelopes from '../../../assets/images/doodles/guestlist/envelopes.svg';
// import nameCardWithQuestionMarks from '../../../assets/images/doodles/namecard_with_question_marks.svg';


export function EmptyState({ imgSrc, hed, body, button, footer }) {
  return (
    <div id="guestlist-empty-state">
      <div className="container">
        <div className="no-guests-content">
          <img src={imgSrc} alt="two envelopes" />
          <h3>{hed}</h3>
          {body && (
            <p>{body}</p>
          )}
          {button && (
            <ButtonV2 onClick={button.action}>{button.text}</ButtonV2>
          )}
          {footer && (
            footer
          )}
        </div>
      </div>
    </div>
  );
}

EmptyState.propTypes = {
  imgSrc: PropTypes.string,
  hed: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  body: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  button: PropTypes.shape({
    action: PropTypes.func,
    text: PropTypes.string,
  }),
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/EmptyState.jsx